/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_ExistsInputs */

const en_directory_submit_enrich_exists = /** @type {(inputs: Directory_Submit_Enrich_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This website is already listed in the directory by another account.`)
};

const zh_directory_submit_enrich_exists = /** @type {(inputs: Directory_Submit_Enrich_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该网站已被其他账号收录在目录中。`)
};

/**
* | output |
* | --- |
* | "This website is already listed in the directory by another account." |
*
* @param {Directory_Submit_Enrich_ExistsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_exists = /** @type {((inputs?: Directory_Submit_Enrich_ExistsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_ExistsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_exists(inputs)
	return zh_directory_submit_enrich_exists(inputs)
});
export { directory_submit_enrich_exists as "directory.submit.enrich.exists" }